import { render, staticRenderFns } from "./TripDetails.vue?vue&type=template&id=4c180a33&scoped=true"
import script from "./TripDetails.vue?vue&type=script&lang=js"
export * from "./TripDetails.vue?vue&type=script&lang=js"
import style0 from "./TripDetails.vue?vue&type=style&index=0&id=4c180a33&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c180a33",
  null
  
)

export default component.exports